import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { reduxForm, Field, change } from 'redux-form'
import SettingsFormField from 'components/Shared/Forms/SettingsFormField'

import { getApp, getInboundLinks } from 'ducks/apps'
import { getTable } from 'ducks/apps/datasources'
import { singularize } from 'utils/strings'
import { getContextualTables } from 'utils/links'
import './ImplicitParamsInputs.scss'

const FORM_NAME = 'ImplicitParamsForm'

function ImplicitParamsInputs({
  contextualTables,
  onTableChange,
  alias,
  aliases,
}) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!contextualTables) return
    contextualTables.forEach(t => {
      const { id: tableId } = t
      const queryVal = aliases[alias]?.query?.[tableId]?.value || undefined
      if (queryVal !== undefined) {
        dispatch(change(FORM_NAME, tableId, queryVal))
      }
    })
  }, [dispatch, alias])

  const handleTableChange = (datasourceId, tableId, value) => {
    if (typeof onTableChange === 'function') {
      onTableChange({ tableId, value, datasourceId })
    }
  }

  const renderContextualTables = () => {
    if (contextualTables.length === 0) return null

    let collections = contextualTables.map(collectionName =>
      collectionName?.name ? singularize(collectionName.name) : null
    )
    collections = collections.filter(collectionItem => collectionItem != null)
    if (collections.length === 0) return null

    return (
      <div>
        <h3 className="implicit-params-inputs-title">Screen Variable Names</h3>
        {contextualTables.map(t => {
          return (
            <Field
              component={SettingsFormField}
              key={t.id}
              name={t.id}
              label={t.name}
              tooltip={`This is the name of the value within the URL itself. Example usage: ${t.name}=123`}
              onChange={e =>
                handleTableChange(t.datasourceId, t.id, e.target.value)
              }
              className="implicit-params-inputs-field"
            />
          )
        })}
      </div>
    )
  }

  // Return the main UI
  return (
    <form className="implicit-params-inputs" autoComplete="off">
      {renderContextualTables()}
    </form>
  )
}

const mapStateToProps = (state, props) => {
  const {
    appId,
    componentId,
    screenId,
    originComponent,
    omitContextualTables,
  } = props

  const app = getApp(state, appId)
  const { deepLinking } = app || {}
  const aliases = deepLinking?.aliases || {}

  let contextualTables = []

  // Build contextual tables if user didn't request to omit them
  if (!omitContextualTables) {
    contextualTables = (
      getContextualTables(
        getApp(state, appId),
        componentId,
        getInboundLinks(state, appId),
        undefined,
        undefined,
        false,
        screenId,
        originComponent
      ) || []
    ).map(opts => {
      return {
        ...opts,
        ...getTable(state, appId, opts.datasourceId, opts.tableId),
        id: opts.tableId,
      }
    })
  }

  return {
    contextualTables,
    app,
    aliases,
  }
}
export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(connect(mapStateToProps)(ImplicitParamsInputs))
